import { Component, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import * as FileSaver from "file-saver";
import { NgxSpinnerService } from "ngx-spinner";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ReportesDefinicionDTO } from "src/app/models/dto/reportes-definicion.dto";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { ReportesService } from "./reportes.service";

@Component({
  selector: "app-reportes",
  templateUrl: "./reportes.component.html",
  styles: [],
})
export class ReportsComponent {
  public columns: ListColumn[] = [];
  public realdata: any[] = [];

  public form: FormGroup;
  public currentDefinicion?: ReportesDefinicionDTO = undefined;
  public definiciones: any[] = [];

  public listSupervisor: any[] = [];
  public listOperador: any[] = [];
  public listUnidad: any[] = [];
  public listTipoUnidad: any[] = [];
  public listEmpresa: any[] = [];

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;
  useFiltro: boolean;
  useRango: boolean;
  useParametros: string[];

  constructor(
    private fb: FormBuilder,
    public service: ReportesService,
    public spinner: NgxSpinnerService,
    private alerts: AlertasSwalService
  ) {}

  public ngOnInit() {
    this.buildForm();
    this.getDefiniciones();
    this.getCombos();
  }
  getCombos() {
    this.service.getCombos("Supervisor").subscribe((s) => {
      this.listSupervisor = s;
    });
    this.service.getCombos("Operador").subscribe((s) => {
      this.listOperador = s;
    });
    this.service.getCombos("TipoUnidad").subscribe((s) => {
      this.listTipoUnidad = s;
    });
    this.service.getCombos("Empresa").subscribe((s) => {
      this.listEmpresa = s;
    });
    this.service.getCombos("Unidad").subscribe((s) => {
      this.listUnidad = s;
    });
  }
  getDefiniciones() {
    this.service.get().subscribe((s) => {
      this.definiciones = s;
    });
  }
  change() {
    if (this.form == undefined) return;

    let cols: string[] = this.currentDefinicion.ColumnasDesc.split("|").filter(
      (f) => f != ""
    );
    let colsPro: string[] = this.currentDefinicion.ColumnasProperty.split(
      "|"
    ).filter((f) => f != "");

    this.columns = cols.map((m, i) => {
      return {
        property: m,
        name: colsPro[i],
        visible: true,
        isModelProperty: true,
      };
    });

    this.useFiltro = this.currentDefinicion.Filtro;
    this.useRango = this.currentDefinicion.Rango;
    this.useParametros = this.currentDefinicion.Parametros.split("|");

    this.realdata = [];
    this.tableComp.setData(this.realdata);
  }
  buscar() {
    var form = this.getReportesParams();
    if (form == null) return;

    this.service.getValues(form).subscribe(
      (resultData) => {
        this.realdata = resultData;
        this.tableComp.setData(this.realdata);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  getPdf() {
    var form = this.getReportesParams();
    if (form == null) return;

    this.spinner.show();
    this.service.getPdf(form).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(response.body, contentType, "reporte.pdf");
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      }
    );
  }

  getCsv() {
    var form = this.getReportesParams();
    if (form == null) return;

    this.spinner.show();
    this.service.getCSV(form).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(response.body, contentType, "reporte.csv");
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      }
    );
  }
  downLoadFile(data: any, contentType: string, filename: string) {
    let blob = new Blob([data], { type: contentType });
    FileSaver.saveAs(blob, filename);
    this.spinner.hide();
  }

  getReportesParams() {
    var form = this.form.value;
    form["IdReportessDefinicion"] =
      this.currentDefinicion.IdReportessDefinicion;

    if (this.useRango) {
      if (form.FechaInicio == "" || form.FechaFinal == "") {
        this.alerts.error("Rango", "El rango es obligatorio");
        return null;
      }
    }
    return form;
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      IdReportessDefinicion: [""],
      Supervisor: [""],
      Operador: [""],
      Unidad: [""],
      Empresa: [""],
      TipoUnidad: [""],
      Filtro: [""],
      FechaInicio: [""],
      FechaFinal: [""],
      SaldosRadios: [0],
      EntradasSalidas: [0],
      Ubicacion: ["X"],
      FechaLimite: [""],
    });
  }
}
